module.exports = __webpack_public_path__ + "img/quest_visualisation_gold_task_flash.12150cb8.svg";